/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:48
 * @LastEditTime: 2021-11-05 16:00:41
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\manageConfig\service\manageConfigPermission.js
 * @Description: 
 */
/*
    create by BaiZhiming 2016-2-24
*/
'use strict';
angular.module('manageConfigPermissionServiceModule', [])
    .factory('manageConfigPermissionService', ['$q', 'trsHttpService', 'globleParamsSet', function($q, trsHttpService, globleParamsSet) {
        return {
            isAdministrator: function() {
                var deffer = $q.defer();
                var flag = false;
                var params = {
                    serviceid: 'mlf_extuser',
                    methodname: 'isAdministrator'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        deffer.resolve(data.ISADMINISTRATOR === 'true');
                    });
                return deffer.promise;
            },
            getPermissionData: function() {
                var deffer = $q.defer();
                var params = {
                    serviceid: 'mlf_metadataright',
                    methodname: 'queryCanOperOfConfiguration',
                    Classify: 'configmodule'
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post')
                    .then(function(data) {
                        deffer.resolve(globleParamsSet.handlePermissionData(data));
                    });
                return deffer.promise;
            }
        };
    }]);
